import React from "react";
import { Dropdown } from 'primereact/dropdown';

import useAttendance from "../../hooks/useAttendance";
import { useDialogService } from "../../hooks/useDialogService";

import { FormattedDateString } from "../../utilities/DateHelper";
import { Severity } from "../../constants/ProConstants";
import _ from 'lodash'

const ProClientAttendance = ({bed, attendance, client})=>{
    const {data:{filter, attendanceOptions}, actions:{MarkAttendance}} = useAttendance({refreshTree:false})
    const {actions:{ShowDialog}} = useDialogService();
    const isClientBilled = !_.isNull(attendance.isBilled)&& attendance.isBilled;
  
    const selectedAttendanceTemplate = (option, props) => {
        if (option) {
            return (
                <div className="attendance-item">                   
                    <div>{option.name}</div>
                </div>
            );
        }
        return (
            <div className="attendance-item">
                <div>{props.placeholder}</div>
            </div>
        );
    }

    const handleChange = async (e)=>{      
       const data = {
           clientId:client.id,
           attendanceCodeId: _.get(e, "value.id") || null,
           bedId:bed.id,
           attendanceDate: FormattedDateString(filter.date),
           clientAttendanceId: (_.get(bed.data, "attendance") && _.get(attendance, "clientAttendanceId")) || null
       }
       if(_.isNull(data.attendanceCodeId)){
                var header =   `Remove recorded attendance for ${client.lastName},${client.firstName} (${client.number}) for ${FormattedDateString(filter.date)}?`
                var labelOk = "Yes, Remove Attendance";
                var labelCancel = "Cancel"
                await ShowDialog(header, null, "", labelOk, labelCancel, Severity.Danger,
                            async ()=>{
                                await MarkAttendance(data) 
                            
                            }, 
                            ()=>{console.log("Cancel Action")});
            }
        else{
                await MarkAttendance(data) 
            }
           
    }

    return    <>
        { isClientBilled && <span className="client-billed">Billed</span>}
                <Dropdown id= {client.id} style={{height:"30px", minWidth:"30%"}} valueTemplate={selectedAttendanceTemplate} placeholder="Attendance" showClear={true}
                value= {((_.get(bed.data, "attendance") && _.get(attendance, "clientAttendanceStatus")) && attendance.clientAttendanceStatus) || null} 
                options={attendanceOptions} onChange={handleChange} optionLabel="name" disabled={isClientBilled} />
        </>

}

export default ProClientAttendance;